/**
 * @generated SignedSource<<94e656db855e6458d4888794e6ceb77c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductizedServiceDeliverables_productizedService$data = {
  readonly deliverables: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly description: string;
        readonly id: string;
        readonly title: string;
      };
    }>;
  };
  readonly " $fragmentType": "ProductizedServiceDeliverables_productizedService";
};
export type ProductizedServiceDeliverables_productizedService$key = {
  readonly " $data"?: ProductizedServiceDeliverables_productizedService$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductizedServiceDeliverables_productizedService">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductizedServiceDeliverables_productizedService",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductizedServiceDeliverableConnection",
      "kind": "LinkedField",
      "name": "deliverables",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductizedServiceDeliverableEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProductizedServiceDeliverable",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "description",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProductizedService",
  "abstractKey": null
};

(node as any).hash = "385bd593beaa436374795bfff773e041";

export default node;
